export {
  DigitalSecurityError,
  withButtonErrorCodes,
} from './DigitalSecurityError';
